<div class="flex flex-col gap-4 h-full">
  <div class="flex flex-wrap justify-between items-center gap-2">
    <div class="flex items-center gap-4">
      <div>
        <beautyapp-datepicker
          [(ngModel)]="currentDate"
          (ngModelChange)="changeDate($event)"
          [allowClear]="false"
        ></beautyapp-datepicker>
      </div>
      <div>
        <div class="ant-btn-group">
          <button nz-button nzType="default" (click)="prevDate()">
            <i nz-icon nzType="left" nzTheme="outline"></i>
          </button>
          <button nz-button nzType="default" (click)="currenDate()">
            <i nz-icon nzType="carry-out" nzTheme="outline"></i>
          </button>
          <button nz-button nzType="default" (click)="nextDate()">
            <i nz-icon nzType="right" nzTheme="outline"></i>
          </button>
        </div>
      </div>
      <div>
        <!-- beaut-546: the unscheduled employees are listed too, in their own
             group. They used to be missing entirely, which left the operator
             unable to move a booking to them — and when nobody was rostered for
             the day the whole dropdown was empty. -->
        <nz-select
          nzShowSearch
          nzAllowClear
          [nzPlaceHolder]="'სხვა თანამშრომელთან გადაწერა'"
          (ngModelChange)="addEmployeeToCalendar($event)"
          [ngModel]="null"
          style="min-width: 240px;">
          @if (scheduledEmployees().length) {
            <nz-option-group nzLabel="გრაფიკით">
              @for (emp of scheduledEmployees(); track emp.id) {
                <nz-option [nzValue]="emp" [nzLabel]="emp.fullName"></nz-option>
              }
            </nz-option-group>
          }
          @if (unscheduledEmployees().length) {
            <nz-option-group nzLabel="გრაფიკის გარეშე">
              @for (emp of unscheduledEmployees(); track emp.id) {
                <nz-option
                  [nzValue]="emp"
                  [nzLabel]="emp.fullName + ' — გრაფიკი არ აქვს'"
                ></nz-option>
              }
            </nz-option-group>
          }
        </nz-select>
      </div>
    </div>

    <!-- beaut-546: says WHY the column is empty and offers the cure. Without
         this the operator sees a non-working day and has no way to tell a real
         day off from a roster nobody filled in. -->
    @if (unscheduledNotice(); as pending) {
      <nz-alert
        nzType="warning"
        nzShowIcon
        [nzMessage]="pending.fullName + '-ს ამ დღეს გრაფიკი არ აქვს'"
        [nzDescription]="noticeActions"
      ></nz-alert>
      <ng-template #noticeActions>
        <div>
          ჯავშნის გადმოტანა მაინც შეგიძლია. გრაფიკის შესავსებად გახსენი
          თანამშრომლის გვერდი.
          <button
            nz-button
            nzType="link"
            nzSize="small"
            data-test="open-employee-schedule"
            (click)="openEmployeeSchedule(pending)"
          >
            გრაფიკის დამატება
          </button>
        </div>
      </ng-template>
    }
    <div>
      <nz-space>
        <div class="ant-btn-group" *nzSpaceItem>
          <button
            nz-button
            [nzType]="timeInterval === '00:05:00' ? 'primary' : 'default'"
            (click)="changeTimeInterval('00:05:00')"
            >
            5 {{ 'calendar.minute' | translate }}.
          </button>
          <button
            nz-button
            [nzType]="timeInterval === '00:15:00' ? 'primary' : 'default'"
            (click)="changeTimeInterval('00:15:00')"
            >
            15 {{ 'calendar.minute' | translate }}.
          </button>
          <button
            nz-button
            [nzType]="timeInterval === '00:20:00' ? 'primary' : 'default'"
            (click)="changeTimeInterval('00:20:00')"
            >
            20 {{ 'calendar.minute' | translate }}.
          </button>
          <button
            nz-button
            [nzType]="timeInterval === '00:30:00' ? 'primary' : 'default'"
            (click)="changeTimeInterval('00:30:00')"
            >
            30 {{ 'calendar.minute' | translate }}.
          </button>
          <button
            nz-button
            [nzType]="timeInterval === '01:00:00' ? 'primary' : 'default'"
            (click)="changeTimeInterval('01:00:00')"
            >
            1{{ 'calendar.hours' | translate }}.
          </button>
        </div>
      </nz-space>

    </div>
  </div>

  <div class="flex-1">
    <full-calendar #calendar [options]="calendarOptions" class="w-full">
      <ng-template #eventContent let-event>
        <!--        <pre>{{event | json}}</pre>-->
        <ng-template #popContent>
          <div class="booking-popup">
            <div><b>{{ 'calendar.popup.employee' | translate }}:</b> {{ event.event.extendedProps.employeeName }}</div>
            @if (event.event.extendedProps.anonymousName || event.event.extendedProps.fullName) {
              <div><b>{{ 'calendar.popup.user' | translate }}
              :</b> {{ event.event.extendedProps.isAnonymous ? event.event.extendedProps.anonymousName : event.event.extendedProps.fullName }}
            </div>
          }
          @if (event.event.extendedProps.mobilePhone) {
            <div><b>{{ 'calendar.popup.mobilePhone' | translate }}:</b> {{ event.event.extendedProps.mobilePhone }}
          </div>
        }
        @if (event.event.extendedProps.services) {
          <div><b>{{ 'calendar.popup.procedure' | translate }}
          :</b> {{ event.event.extendedProps.services ? event.event.extendedProps.services : 'N/A' }}
        </div>

      }
      @if (event.event.extendedProps.price) {
        <div><b>{{ 'calendar.popup.price' | translate }}:</b> {{ event.event.extendedProps.price }} GEL</div>
      }
      @if (event.event.extendedProps.salePrice) {
        <div><b>{{ 'calendar.popup.discount' | translate }}
        :</b> {{ event.event.extendedProps.salePrice }}
      </div>
    }
    @if (event.event.extendedProps.type) {
      <div><b>{{ 'calendar.popup.status' | translate }}:</b> {{ event.event.extendedProps.type }}</div>
    }
    <div><b>{{ 'calendar.popup.times' | translate }}
    :</b> {{ (event.event.start | date : 'HH:mm') + ' - ' + (event.event.end | date : 'HH:mm') }}
  </div>

  @if (event.event.extendedProps.description) {
    <div><b>{{ 'calendar.popup.comment' | translate }}
    :</b> {{ event.event.extendedProps.description }}
  </div>
}
@if (event.event.extendedProps.createdAt) {
  <div><b>{{ 'calendar.popup.bookedAt' | translate }}
  :</b> {{ event.event.extendedProps.createdAt | date: 'dd/MM/yyyy HH:mm' }}
</div>
}
@if (event.event.extendedProps.createdB) {
  <div><b>{{ 'calendar.popup.bookedBy' | translate }}:</b> {{ event.event.extendedProps.createdBy }}</div>

}

@if (event.event.extendedProps.completedBy) {
  @if (event.event.extendedProps.completedBy) {
    <div><b>{{ 'calendar.popup.completedBy' | translate }}
    :</b> {{ event.event.extendedProps.completedBy }}
  </div>
}
}

</div>
</ng-template>
<div class="fc-event-title"
  nz-popover
  [nzPopoverTitle]="(event.event.extendedProps.bookingDate | date:'dd/MM/yyyy') +' - '+(event.event.start | date : 'HH:mm') + '-' + (event.event.end | date : 'HH:mm')"
  [nzPopoverContent]="popContent"
  nzPopoverPlacement="topLeft"
  >
  <div class="fc-event-title__name" style="--fc-event-title__name-color: {{ event.event.extendedProps.type === 'day-off' ? '#f5222d' : '#1890ff' }};">
    <div  >
      @if (event.event?.display === 'background') {
        <span
          nz-icon
          nzType="clock-circle"
          nzTheme="fill"
        ></span>
      }
      {{ event.event?.title }}
    </div>
    <div>
      {{ event.event?.extendedProps?.services }}
    </div>
  </div>
</div>
</ng-template>
<ng-template #resourceLabelContent let-resource>
  <div
    nz-row
    [nzGutter]="[10, 10]"
    nzAlign="middle"
    nzJustify="space-between"
    class="fc-resource-title"
    >
    <div nz-col class="fc-resource-title__name">
      {{ resource.resource.title }}
    </div>
    @if (!isOriginalEmployee(resource.resource.id)) {
      <div nz-col>
        <button nz-button nzType="text" nzSize="small" nzDanger (click)="removeEmployeeFromCalendar(resource.resource.id)">
          <i nz-icon nzType="close" nzTheme="outline"></i>
        </button>
      </div>
    }
  </div>
</ng-template>
</full-calendar>
</div>
<!-- beaut-388: warn when a booking is being moved onto an employee who isn't
     working that date. Mirrors the edit-booking-info conflict alert. -->
@if (hasAvailabilityConflicts()) {
  <nz-alert
    class="block mb-2"
    nzType="warning"
    [nzMessage]="'გაფრთხილება: კონფლიქტები აღმოჩენილია'"
    [nzDescription]="conflictsTemplate"
    nzShowIcon
  ></nz-alert>
  <ng-template #conflictsTemplate>
    <ul class="list-disc pl-4">
      @for (conflict of availabilityConflicts(); track conflict.id) {
        <li [class]="conflict.severity === 'hard' ? 'text-red-600' : 'text-orange-600'">
          @switch (conflict.type) {
            @case ('employee') {
              <strong>თანამშრომელი:</strong> {{ getConflictMessage(conflict) }}
            }
            @case ('room') {
              <strong>ოთახი:</strong> {{ getConflictMessage(conflict) }}
            }
            @case ('service') {
              <strong>სერვისი:</strong> {{ getConflictMessage(conflict) }}
            }
            @case ('schedule') {
              <strong>განრიგი:</strong> {{ getConflictMessage(conflict) }}
            }
            @case ('break') {
              <strong>შესვენება:</strong> {{ getConflictMessage(conflict) }}
            }
          }
        </li>
      }
    </ul>
  </ng-template>
}
<div class="flex-initial flex justify-end gap-2">
  @if (hasAvailabilityConflicts()) {
    <button
      nz-button
      nzType="default"
      nzDanger
      [nzLoading]="saving()"
      nzSize="large"
      (click)="confirmDespiteConflicts()"
    >
      მაინც შენახვა
    </button>
  } @else {
    <!--
      beaut-394: @else, not a second button alongside the first.

      changeSchedule() returns early whenever proceedDespiteConflicts() is
      false and the check finds conflicts. Once the warning is showing, the
      employee and time have not changed, so a re-check returns the same
      conflicts and this button can never succeed — it looked broken.

      Safe to hide because resetAvailabilityCheck() clears the conflicts on
      every change that could resolve them (drag/move, add or remove an
      employee, change the date), which brings this button straight back.

      Matches add-booking and edit-booking-info, which already do this.
    -->
    <button
      nz-button
      (click)="changeSchedule()"
      nzType="primary"
      [nzLoading]="saving() || isCheckingAvailability()"
      nzSize="large"
    >
      {{ 'buttons.save' | translate }}
    </button>
  }
</div>
</div>
